import {
    connect,
    injectSaga,
} from '@vfde-fe/sails_core';
import { ADDITIONAL_PAGE_OPTIONS } from '@vfde-fe/sails-constants';
import {
    CONTAINER_OPTIONS,
} from 'Constant';
import { selectHardwareOnly, selectName } from '../DeviceDetail/selectors';
import optionsSaga from './saga';
import { createStructuredSelector } from 'reselect';
import { RootState } from '../DeviceDetail/types';
import {
    selectAtomicId,
    selectCapacities,
    selectCapacitiesForColor,
    selectColors,
    selectCurrentCapacity,
    selectCurrentColor,
    selectDeliveryDate,
    selectDeliveryScope, selectForceRerender,
    selectImages,
    selectTechnicalDetails,
} from './selectors';
import {
    changeCapacity,
    changeColor,
    setDefaultState,
} from './actions';
import { mountColorOptionPicker } from '../../components/mountColorOptionPicker';
import { mountCapacityOptionPicker } from '../../components/mountCapacityOptionPicker';
import mountImageGallery from '../../components/mountImageGallery';
import mountIconText, { updateDeliveryDate } from '../../components/mountIconText';
import { mountTechnicalDetailsAccordion } from '../../components/mountTechnicalDetailsAccordion';
import { StateProps } from './interface';
import {
    DELIVERY_DATE_CONTAINER,
    DELIVERY_DATE_MOBILE_CONTAINER,
    COLOR_PICKER_CONTAINER,
    CAPACITY_PICKER_CONTAINER,
    IMAGE_GALLERY_CONTAINER,
} from './constants';
import mountFeatureTile from '../../components/mountFeatureTile';

function Options (state, actions) {
    injectSaga(CONTAINER_OPTIONS, optionsSaga);

    // Set initial color and capacity from session storage or default (first) value in API
    actions.setDefaultState(window[ADDITIONAL_PAGE_OPTIONS]);

    const deliveryDate = mountIconText(DELIVERY_DATE_CONTAINER);
    const deliveryDateMobile = mountIconText(DELIVERY_DATE_MOBILE_CONTAINER);
    mountColorOptionPicker(COLOR_PICKER_CONTAINER, state, actions.changeColor);
    mountCapacityOptionPicker(CAPACITY_PICKER_CONTAINER, state, actions.changeCapacity);

    let isFirstAccordionMount = true;

    return {
        getDerivedStateFromProps (newState, oldState) {
            const {atomicId} = newState;
            const atomicIdUpdated = atomicId !== oldState.atomicId;

            if (newState.availableCapacities && newState.availableCapacities) {
                mountCapacityOptionPicker(CAPACITY_PICKER_CONTAINER, newState, actions.changeCapacity);
            }

            if (newState.currentColor && newState.currentColor !== oldState.currentColor) {
                mountImageGallery(IMAGE_GALLERY_CONTAINER, newState.images);
                mountColorOptionPicker(COLOR_PICKER_CONTAINER, newState, actions.changeColor);
            }

            if (newState.atomicId && atomicIdUpdated) {
                mountTechnicalDetailsAccordion( newState.technicalDetails, newState.deliveryScope, isFirstAccordionMount);
                updateDeliveryDate(deliveryDate, newState.deliveryDate.shippingDate);
                updateDeliveryDate(deliveryDateMobile, newState.deliveryDate.shippingDate);

                isFirstAccordionMount = false;
            }
        },
    };
}
const mapStateToProps = createStructuredSelector<RootState, StateProps>({
    colors: selectColors(),
    capacities: selectCapacities(),
    availableCapacities: selectCapacitiesForColor(),
    currentColor: selectCurrentColor(),
    currentCapacity: selectCurrentCapacity(),
    images: selectImages(),
    atomicId: selectAtomicId(),
    technicalDetails: selectTechnicalDetails(),
    deliveryDate: selectDeliveryDate(),
    deliveryScope: selectDeliveryScope(),
    isHardwareOnly: selectHardwareOnly(),
    name: selectName(),
    forceRerender: selectForceRerender(),
});

const mapDispatch = {
    changeColor,
    changeCapacity,
    setDefaultState,
};

const mountOptionsContainer = connect(mapStateToProps, mapDispatch)(Options);

export default mountOptionsContainer;
